import React from 'react';
import './ImageCard.css';

interface ImageCardProps {
    imagePath: string; // Pfad zum Bild in deinen Assets
    // title: string;
    // text: string;
    // color?: string; // Optional, falls du den Titel einfärben möchtest
    className?: string; // Für die Animation
}

const ImageCard: React.FC<ImageCardProps> = ({ imagePath, className }) => {
    return (
        <div className={`imagecard ${className || ''}`}>
            <img src={imagePath} alt="Card" className="imagecard" />
            {/*<h3 className="card-title" style={{ color }}>{title}</h3>*/}
            {/*<p className="card-text">{text}</p>*/}
        </div>
    );
};

export default ImageCard;
